import { render, staticRenderFns } from "./NewDesignBlogPost.vue?vue&type=template&id=7117fa45&"
import script from "./NewDesignBlogPost.vue?vue&type=script&lang=js&"
export * from "./NewDesignBlogPost.vue?vue&type=script&lang=js&"
import style0 from "./NewDesignBlogPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageComponent: require('/app/components/ImageComponent.vue').default,ATextblock: require('/app/components/ATextblock.vue').default,ACardset: require('/app/components/ACardset.vue').default})
